export const navBarRouterPathURl = '/frontend';

export const partnerNameFromUrl = '/frontend';

export const defaultAppVersion = "1.0.0";


export const PARTNER_TYPE = {
  "exhibition company": "Exhibitors",
  "b2b publisher": "Advertisers",
  "growth hub": "Members",
  "innovation centre": "Members",
  "trade body": "Members",
  "chamber of commerce": "Members",
};

export const EXISTING_MEMBER_QUESTIONS = {
  "exhibition company": "Are you an Existing Exhibitor?",
  "b2b publisher": "Are you an Existing Advertiser?",
  "growth hub": "Are you an Existing Client?",
  "innovation centre": "Are you an Existing Member?",
  "trade body": "Are you an Existing Member?",
  "chamber of commerce": "Are you an Existing Member?",
};